import { z } from 'zod';

const stringArraySchema = z.array(z.string());
const stringTupleListSchema = z
  .array(z.array(z.string()).min(1).max(2))
  .min(1);

const validateJsonInput = (
  jsonInput: string | undefined,
  schema: z.ZodTypeAny
) => {
  if (!jsonInput) return false;

  try {
    const parsedData = JSON.parse(jsonInput);
    schema.parse(parsedData);
    return false;
  } catch (error) {
    if (error instanceof z.ZodError) {
      return error.errors
        .map(err => `${err.path.join('.')}: ${err.message}`)
        .join(', ');
    }

    if (error instanceof SyntaxError) {
      return 'JSON Syntax Error';
    }

    return 'Invalid JSON';
  }
};

export const validateTtsRemoveExactMatches = (jsonInput?: string) => {
  return validateJsonInput(jsonInput, stringArraySchema);
};

export const validateTtsRemoveMarkers = (jsonInput?: string) => {
  return validateJsonInput(jsonInput, stringTupleListSchema);
};
